import { useContext,  useState } from "react";
import { theme } from "../../theme";
// import {  withStyles } from "@mui/styles";

import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItem from "@mui/material/ListItem";
import Checkbox from "@mui/material/Checkbox";

import { BiTrash, BiEdit, BiCheck } from "react-icons/bi";
import { dataType } from "../GenericList/GenericList";
import { registrationStatus } from "../../dataProvider/interfaces/IAttendee";
import { StoreContext } from "../../store/Store";
import ISessionLocation from "../../dataProvider/interfaces/ISessionLocation";
import { MdRemoveRedEye } from "react-icons/md";
import { IoMdCopy } from "react-icons/io";
import { BsPinAngle } from "react-icons/bs";
import { genericListItem as classes } from "./styles";

export interface Props {
  item: any;
  index: number;
  type: dataType;
  onSelect: Function;
  isSelected?: boolean; // row item is selected/unselected
  onDelete?: Function;
  onEdit?: Function;
  onDuplicate?: Function;
  onItemCheck?: Function;
  setDefault?: Function;
  isChecked?: boolean; // item checkbox is checked/unchecked
}

const ItemSummary = ({
  item,
  type,
  actions,
}: {
  item: any;
  type: dataType;
  actions: {
    onDelete?: Function;
    onEdit?: Function;
    onDuplicate?: Function;
    setDefault?: Function;
  };
}) => {
  const [state] = useContext(StoreContext);

  const getPrimaryInfo = () => {
    if (type === dataType.USERS) {
      return `${item.fullName}`;
    }

    if (type === dataType.ATTENDEES) {
      return `${item.name ||
        `${item.firstName} ${item.lastName}` ||
        `${item.fieldValues && item.fieldValues.fname} ${item.fieldValues && item.fieldValues.lname
        }`
        }`;
    }

    if (type === dataType.SESSIONS) {
      return `${item.name}`;
    }

    if (type === dataType.BADGE_FORMATS) {
      return `${item.name}`;
    }

    if (type === dataType.RESERVATIONS) {
      return `${item.attendeeName || item.attendeeThirdPartyID}`;
    }

    if (type === dataType.ACCOUNTS) {
      return `${item.name}`;
    }
  };

  const getSecondaryInfo = () => {
    if (type === dataType.USERS) {
      return `${item.profile.name}`;
    }

    if (type === dataType.ATTENDEES) {
      return `${item.jobTitle || (item.fieldValues && item.fieldValues.title) || ""
        }`;
    }

    if (type === dataType.SESSIONS) {
      const locationId = item.location;
      const location = state.sessionLocations.filter(
        (location: ISessionLocation) => location.id === locationId
      )[0];

      return `${location?.name || item["sessionLocation"] || ""}`;
    }

    if (type === dataType.BADGE_FORMATS) {
      return `${item.width} x ${item.height} mm`;
    }
  };

  const getAdditionalInfo = () => {
    if (type === dataType.USERS) {
      return `${item.status}`;
    }

    if (type === dataType.ATTENDEES) {
      return `${item?.company || item?.Company || (item.fieldValues && (item.fieldValues?.company || item.fieldValues?.Company)) || ""
        }`;
    }

    if (type === dataType.BADGE_FORMATS) {
      if (item.doubleSided) {
        return "double sided";
      } else {
        return "single sided";
      }
    }
  };

  const primaryInfo = getPrimaryInfo();
  const secondaryInfo = getSecondaryInfo();
  const additionalInfo = getAdditionalInfo();
  const statusColor = {
    [registrationStatus.INCOMPLETE]: "#F6A316",
    [registrationStatus.CONFIRMED]: "#1798e5",
    [registrationStatus.ATTENDED]: "#7BB225",
    [registrationStatus.NO_SHOW]: "#F64D16",
    other: "#A8A8A8",
  };
  return (
    <Box sx={classes.attendeeDetails} className="attendeeDetails">
      <Box flexGrow="1">
        <Box sx={classes.attendeeName} component="span" mr={1}>
          {primaryInfo}
        </Box>
        {type === dataType.ATTENDEES && 
         item?.registrationStatus && (<Box
         bgcolor={
           (item.registrationStatus === registrationStatus.DEFAULT &&
             statusColor[registrationStatus.CONFIRMED]) ||
           (item.registrationStatus === registrationStatus.INCOMPLETE &&
             statusColor[registrationStatus.INCOMPLETE]) ||
           (item.registrationStatus === registrationStatus.CONFIRMED &&
             statusColor[registrationStatus.CONFIRMED]) ||
           (item.registrationStatus === registrationStatus.ATTENDED &&
             statusColor[registrationStatus.ATTENDED]) ||
           (item.registrationStatus === registrationStatus.NO_SHOW &&
             statusColor[registrationStatus.NO_SHOW]) ||
           statusColor.other
         }
         sx={classes.registrationStatus}
         component="span"
         mr={1}
       >
         {/* {item.registrationStatus || registrationStatus.CONFIRMED} */}
         {item.registrationStatus}
       </Box>
        )}
        <Box sx={classes.attendeeTitle} component="span" mr={1}>
          {secondaryInfo}
        </Box>
        <Box sx={classes.attendeeCompany} component="span">
          {additionalInfo}
        </Box>
        {type === dataType.BADGE_FORMATS && item.default && (
          <Box
            component="span"
            sx={classes.registrationStatus}
            bgcolor={theme.palette.grey["800"]}
            ml={1}
          >
            DEFAULT
          </Box>
        )}
      </Box>

      <Box sx={classes.actions}>
        {actions.onEdit && (
          <BiEdit
            title="Edit"
            style={classes.actionIcon}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              actions.onEdit && actions.onEdit(item);
            }}
          />
        )}

        {type === dataType.BADGE_FORMATS && !item.default && (
          <>
            {actions.setDefault && (
              <BsPinAngle
                title="Set Default"
                style={classes.actionIcon}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  actions.setDefault && actions.setDefault(item);
                }}
              />
            )}
          </>
        )}

        {actions.onDuplicate && (
          <IoMdCopy
            title="Duplicate"
            style={classes.actionIcon}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              actions.onDuplicate && actions.onDuplicate(item);
            }}
          />
        )}

        {actions.onDelete && (
          <BiTrash
            title="Delete"
            style={classes.actionIcon}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              actions.onDelete && actions.onDelete(item);
            }}
          />
        )}

        {type === dataType.SESSIONS && (
          <Box
            sx={{
              visibility: "hidden",
              marginLeft: "10px",
              zIndex: 10,
              fontSize: "16px",
              display: "flex",
            }}
            className="viewIcon"
          >
            <MdRemoveRedEye />
          </Box>
        )}
      </Box>
    </Box>
  );
};

// this component was refactored from the attendee list item (vars naming was not updated in all places)
const GenericListItem = ({
  item,
  index,
  type,
  onSelect,
  isSelected,
  onDelete,
  onEdit,
  onDuplicate,
  onItemCheck,
  setDefault,
  isChecked,
}: Props) => {
  const [amount, ] = useState(item?.defaultRestrictAccessAmount);

  const getAvatar = () => {
    if (
      isChecked &&
      type !== dataType.SESSIONS &&
      type !== dataType.RESERVATIONS &&
      type !== dataType.BADGE_FORMATS
    ) {
      return (
        <Avatar sx={classes.checkedAvatar}>
          <BiCheck />
        </Avatar>
      );
    }

    if (type === dataType.ATTENDEES) {
      return item.imageUrl ? (
        <Avatar
          className="attendeeAvatar"
          sx={{ marginRight: "14px" }}
          src={item.imageUrl}
        />
      ) : (
        <Avatar className="attendeeAvatar" sx={{ marginRight: "14px" }}>
          {(item.firstName && item.firstName[0]) ||
            (item.fieldValues?.fname && item.fieldValues?.fname[0])}
        </Avatar>
      );
    }

    if (type === dataType.USERS) {
      return item.image ? (
        <Avatar
          className="attendeeAvatar"
          sx={{ marginRight: "14px" }}
          src={item.image}
        />
      ) : (
        <Avatar className="attendeeAvatar" sx={{ marginRight: "14px" }}>
          {item.fullName[0]}
        </Avatar>
      );
    }

    if (type === dataType.ACCOUNTS) {
      return (
        <Avatar
          className="attendeeAvatar"
          sx={{ marginRight: "14px" }}
          src={item.image}
        />
      );
    }

    return <></>;
  };

  const handleSelectItem = (item: any) => {
    onSelect(item);
  };

  const avatar = getAvatar();

  return (
    <ListItem
      // button
      sx={[
        classes.listItemAction,
        {
          backgroundColor: index % 2 ? "#fff" : theme.palette.grey[600],
          cursor: "pointer",
        },
      ]}
      className={isSelected ? "activeRow" : "attendeeRow"}
      selected={isSelected}
      onClick={() => {
        handleSelectItem(item);
      }}
    >
      <ListItemIcon
        className="checkboxIcon"
        sx={classes.checkboxIcon}
        style={
          typeof onItemCheck !== "function"
            ? { display: "none" }
            : type === dataType.SESSIONS ||
              type === dataType.RESERVATIONS ||
              type === dataType.BADGE_FORMATS
              ? { display: "block", minWidth: "40px", left: "0" }
              : {}
        }
      >
        <Checkbox
          sx={classes.greyCheckboxInput}
          className="greyCheckboxInput"
          edge="start"
          checked={isChecked}
          onChange={(e) => {
            if (typeof onItemCheck === "function") {
              type === dataType.RESERVATIONS // for reservations we pass the attendee id when selecting items
                ? onItemCheck(item.attendeeId)
                : onItemCheck(item.id, amount);
            }
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          disableRipple
        />
      </ListItemIcon>
      <ListItemAvatar
        sx={{
          minWidth: "initial",
        }}
        className="avatarIcon"
        style={typeof onItemCheck !== "function" ? { display: "block" } : {}}
      >
        {avatar}
      </ListItemAvatar>
      <ListItemText
        primary={
          <ItemSummary
            item={item}
            type={type}
            actions={{ onDelete, onEdit, onDuplicate, setDefault }}
          />
        }
        secondary={null}
      />
    </ListItem>
  );
};

export default GenericListItem;
